var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurationaproximite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#d51c83;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#d51c83;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.19,12.36l-.62-.6c0-.57.08-1.08.75-1.19a.81.81,0,0,1,.94.55C44.53,11.75,44.14,12.19,43.19,12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.54,38.9a.27.27,0,0,1-.11-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.78,27.69l-.21-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,36.73l0,.58C11.68,37.13,11.86,36.93,12,36.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.25,28l.36.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.78,37.31a2.58,2.58,0,0,1,.08-.26C30.94,37.17,31,37.29,30.78,37.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.78,39.06l-.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.67,36.59l.08.23a.65.65,0,0,1-.1-.15S32.67,36.62,32.67,36.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.31,35.25a.27.27,0,0,1-.11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.32,31.17,41.18,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.06,30.78l.13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.57,29.09l-.19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.59,22.55l.1-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.91,24.37l-.13-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.2,18.39l.08-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.73,24.45l-.37.11A.31.31,0,0,1,44.73,24.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.78,24.08l-.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.18,23.87,46,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.79,23.45l-.16.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 43.36,
    cy: 11.46,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.36,14.09a5.26,5.26,0,1,0,5.26,5.26A5.26,5.26,0,0,0,43.36,14.09Zm0,8.78a3.58,3.58,0,1,1,3.57-3.58A3.57,3.57,0,0,1,43.36,22.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.7,12.33c6.27,2,4.22,9.57,1.36,13.47a33.76,33.76,0,0,1-5.23,5.59H44.1a42.33,42.33,0,0,1-4.91-4.93c-3.44-4.12-5.21-11.6,1.29-14.13,1.07-.42.6-2.16-.48-1.74a9.74,9.74,0,0,0-5.36,12c1.43,3.93,5.07,7.37,8.19,10a.92.92,0,0,0,1.27,0c3.22-2.76,6.62-6.39,8-10.47,1.58-4.63-.09-10.07-4.94-11.6-1.1-.35-1.58,1.39-.47,1.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.37,
    y: 37.37,
    width: 27.86,
    height: 1.8,
    rx: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.29,37.37c1,0,1.66-10.56,12.09-10.57,9.48,0,10.93,10.55,11.82,10.56s-1.36.13-2.34.2-2.05-8.89-9.63-8.89c-8.52,0-8.83,8.81-9.75,8.88S8.33,37.4,9.29,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.18,31l3.55,1.16a1.33,1.33,0,0,0-.37.74c0,.36-.27,4.73.18,6s2.13,1,4.08,1.06a3.74,3.74,0,0,1,3.56,3.42A3.63,3.63,0,0,1,48.42,47c-2.53,0-18.92,0-18.92,0s-2-.25-2,2.16S27.88,55,24,55.4,20.44,51.21,20.44,50s0-10.67,0-10.67a3.75,3.75,0,0,0-.76-.11l2.55-.05,0,2-.06,10s-.12,2.53,1.68,2.49,1.81-1.49,1.81-1.49l0-3.46s.33-3.34,3-3.42,19.3-.09,19.3-.09,2.28.28,2.27-1.58a1.73,1.73,0,0,0-1.8-1.81l-3.35-.07a3.47,3.47,0,0,1-2.66-3.44c0-2.88,0-4.53,0-4.53A3.5,3.5,0,0,0,41.18,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.46,26.93a2.48,2.48,0,0,1,0-.27,1.81,1.81,0,0,1,3.62,0,2.11,2.11,0,0,1,0,.25,11.2,11.2,0,0,1,1.49.33,3.36,3.36,0,0,0,.08-.71,3.31,3.31,0,0,0-6.62,0,3.11,3.11,0,0,0,.07.69A11.32,11.32,0,0,1,19.46,26.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurationaproximite);
export default __webpack_public_path__ + "static/media/restaurationaproximite.56f5cd5e41d176b81e6b883d53296d73.svg";
export { ForwardRef as ReactComponent };